module.exports = __webpack_public_path__ + "img/stock3.987a6424.png";